<script lang="ts">
  import ScheduleEventActionValidationDialogs from "./_modules/schedule-event-action-validation-dialogs"
  import RootHost from "./routes/Root"
</script>

<RootHost />
<ScheduleEventActionValidationDialogs />
